import React from 'react';

export const ContactUs = (props) => {
  return (
    <div className="flex flex-col space-y-4">
      <p className="font-light text-2xl text-gray-900">
        Don’t see the stack you are looking for?
      </p>
      <button
        onClick={() => props.setShowModal(true)}
        className="bg-primary font-bold px-8 py-2 rounded text-white text-xl w-content"
      >
        Contact Us
      </button>
    </div>
  )
}